import styled from 'styled-components';

interface ActionPathPanelWrapProps {
  rtl?: boolean;
}

export const ActionPathPanelWrap = styled.div<ActionPathPanelWrapProps>`
  display: flex;
  position: fixed;
  width: 100%;
  height: auto;
  bottom: 50px;
  z-index: 1;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex-direction: column-reverse;
  pointer-events: none;
  text-align: center;
  direction: ${(props) => (props.rtl ? 'rtl' : 'ltr')};
  @media (max-width: 480px) {
    bottom: 100px;
  }
`;

export const ActionPathPanel = styled.div<{ navigationMode?: boolean }>`
  min-height: 64px;
  z-index: 1;
  pointer-events: all;

  @media (max-width: 480px) {
    width: calc(100% - 16px);
    margin-left: 8px;
    margin-right: 8px;
  }
  @media (min-width: 481px) {
    min-width: 465px;
    max-width: 680px;
    width: ${(props) => (props.navigationMode ? '100%' : 'unset')};
  }
`;

export const TopBarWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

export const TopBar = styled.div<{ bgColor?: string }>`
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.bgColor ? props.bgColor : 'rgba(0, 0, 0, 0.4)')};
  border-radius: 10px 10px 0 0;
  height: 30px;
  backdrop-filter: blur(7.5px);
`;

export const Distance = styled.div<ActionPathPanelWrapProps>`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  border-right: ${(props) => (props.rtl ? 'none' : '1px solid rgba(255, 255, 255, 0.15)')};
  border-left: ${(props) => (props.rtl ? '1px solid rgba(255, 255, 255, 0.15)' : 'none')};
`;

export const DistanceText = styled.span<{ textColor?: string }>`
  padding: 8px 12px;
  font-family: Inter, Heebo, sans-serif;
  color: ${(props) => (props.textColor ? props.textColor : 'white')};
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 105%;
  letter-spacing: 0.15px;
`;

export const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 45px;
  margin: 0;
  background-color: transparent;
`;

export const BottomBar = styled.div<{
  vertical?: boolean;
  navigationMode?: boolean;
  bgColor?: string;
  rtl?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  padding: 14px;
  border-radius: ${(props) =>
    props.navigationMode
      ? props.rtl
        ? '0 20px 0 0'
        : '20px 0 0 0'
      : props.rtl
        ? '0 20px 20px 20px'
        : '20px 0 20px 20px'};
  background-color: ${(props) => (props.bgColor ? props.bgColor : 'rgba(0, 0, 0, 0.75)')};
  margin-left: auto;
  box-shadow: 0 5px 6px -3px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(7.5px);
  @media (max-width: 480px) {
    flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};
    padding: 12px;
  }
`;

export const BottomBarInfo = styled.div<{ grow?: boolean; expanded: string }>`
  display: flex;
  flex-grow: ${(props) => (props.grow ? 1 : 0)};
  width: ${(props) => (props.expanded ? '100%' : 'auto')};
  align-items: center;
  //@media (min-width: 481px) {
  //  min-width: 465px;
  //  max-width: 680px;
  //}
`;

export const BottomBarIcon = styled.img`
  width: 60px;
  height: 60px;
  min-width: 60px;
  min-height: 60px;
  border-radius: 9px;
  background-color: transparent;
`;

export const BottomBarText = styled.div<{
  alignText?: string;
  flexGrow?: number;
  textColor?: string;
  descriptionText?: boolean;
}>`
  flex-grow: ${(props) => (props.flexGrow ? props.flexGrow : 0)};
  margin-left: 8px;
  margin-right: 8px;
  text-align: ${(props) => (props.alignText ? props.alignText : 'left')};
  letter-spacing: 0.15px;
  font-family: Inter, Heebo, sans-serif;
  font-weight: ${(props) => (props.descriptionText ? 400 : 'bold')};
  color: ${(props) => (props.textColor ? props.textColor : 'white')};

  @media (max-width: 480px) {
    font-size: ${(props) => (props.descriptionText ? '15px' : '17px')};
    max-height: 60px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 120%;
  }
  @media (min-width: 481px) {
    font-size: 15px;
    line-height: 105%;
  }
`;

export const BottomBarButtons = styled.div<{
  expanded?: boolean;
  marginLeft?: string | number;
  marginTop?: string | number;
  rtl?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: ${(props) => (props.expanded ? 1 : 0)};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : 0)};
  @media (max-width: 480px) {
    width: ${(props) => (props.expanded ? '100%' : 'auto')};
  }
  :last-of-type {
    margin-left: ${(props) => (props.rtl ? 0 : props.marginLeft ? props.marginLeft : 0)};
    margin-right: ${(props) => (props.rtl ? (props.marginLeft ? props.marginLeft : 0) : 0)};
  }
`;

export const PlayButton = styled.button<{
  bg?: string;
  expanded?: boolean;
  navigationMode?: boolean;
  rtl?: boolean;
}>`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  width: ${(props) => (props.expanded ? '140px' : props.navigationMode ? '103px' : '42px')};
  height: 42px;
  background: ${(props) => (props.bg ? props.bg : '#2055ff')};
  transition-duration: 0.2s;
  :hover {
    background: ${(props) =>
      `linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), ${
        props.bg || '#2055ff'
      }`};
  }
  :active {
    background: ${(props) =>
      `linear-gradient(0deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0.35)), ${
        props.bg || '#2055ff'
      }`};
  }
  border-radius: 35px;
  box-sizing: border-box;
  margin-right: ${(props) => (props.rtl ? '0' : '4px')};
  margin-left: ${(props) => (props.rtl ? '4px' : '0')};
  @media (max-width: 480px) {
    flex-grow: ${(props) => (props.expanded ? 1 : 0)};
    flex-shrink: 0;
    flex-basis: 0;
  }
`;

export const TeleportButton = styled.button<{ expanded?: boolean; rtl?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  width: ${(props) => (props.expanded ? '140px' : '42px')};
  height: 42px;
  background-color: white;
  border-radius: 35px;
  box-sizing: border-box;
  border: 1px solid #2055ff;
  margin-left: ${(props) => (props.rtl ? '0' : '4px')};
  margin-right: ${(props) => (props.rtl ? '4px' : '0')};
  transition-duration: 0.2s;
  :hover {
    background: #e1e1e1;
    border: 1px solid #2055ff;
  }
  :active {
    background: #e1e1e1;
    border: 1px solid #2055ff;
  }
  :focus {
    border: 1px solid #2055ff;
  }

  @media (max-width: 480px) {
    flex-grow: ${(props) => (props.expanded ? 1 : 0)};
    flex-shrink: 0;
    flex-basis: 0;
  }
`;

export const ButtonText = styled.span<{ color?: string }>`
  margin: 0 8px;
  font-family: Inter, Heebo, sans-serif;
  line-height: normal;
  font-size: 16px;
  font-weight: bold;
  color: ${(props) => (props.color ? props.color : 'black')};
`;
